import { IDictionary } from 'models/dictionary';
import { EFirearmType } from 'pages/AncillariesPage/AncillariesReferenceTablePage/ARTComponentsForm/helpers';
import { EArtComponentType } from 'constants/ArtAccessoryType';

export const getFirearmTypesForComponent = (
  firearmType: IDictionary[] | null,
  componentType: string | null,
): IDictionary[] => {
  if (firearmType === null) return [];
  if (componentType === null) return firearmType;

  const exclude = (ids: EFirearmType[]): IDictionary[] =>
    firearmType.filter((it) => !ids.includes(it.name as EFirearmType));

  switch (componentType) {
    case EArtComponentType.UPPER_RECEIVER:
      return exclude([
        EFirearmType.CANNON,
        EFirearmType.HANDGUN,
        EFirearmType.ROCKET_LAUNCHER,
        EFirearmType.MANPAD,
        EFirearmType.ANTI_TANK_MISSILE,
      ]);
    case EArtComponentType.LOWER_RECEIVER:
      return exclude([EFirearmType.CANNON, EFirearmType.HANDGUN]);
    case EArtComponentType.FRAME:
      return exclude([]);
    case EArtComponentType.BARREL:
      return exclude([]);
    case EArtComponentType.BOLT:
      return exclude([
        EFirearmType.GRENADE_LAUNCHER,
        EFirearmType.RECOILLESS_RIFLE,
        EFirearmType.ROCKET_LAUNCHER,
        EFirearmType.MANPAD,
        EFirearmType.ANTI_TANK_MISSILE,
      ]);
    case EArtComponentType.SLIDE:
      return exclude([
        EFirearmType.CANNON,
        EFirearmType.COMBINATION_GUN,
        EFirearmType.GRENADE_LAUNCHER,
        EFirearmType.MACHINE_GUN,
        EFirearmType.RIFLE,
        EFirearmType.SHOTGUN,
        EFirearmType.SUBMACHINE_GUN,
        EFirearmType.RECOILLESS_RIFLE,
        EFirearmType.ROCKET_LAUNCHER,
        EFirearmType.MANPAD,
        EFirearmType.ANTI_TANK_MISSILE,
      ]);
    case EArtComponentType.CYLINDER:
      return exclude([
        EFirearmType.CANNON,
        EFirearmType.COMBINATION_GUN,
        EFirearmType.MACHINE_GUN,
        EFirearmType.RIFLE,
        EFirearmType.SHOTGUN,
        EFirearmType.SUBMACHINE_GUN,
        EFirearmType.RECOILLESS_RIFLE,
        EFirearmType.ROCKET_LAUNCHER,
        EFirearmType.MANPAD,
        EFirearmType.ANTI_TANK_MISSILE,
      ]);
    default:
      return firearmType;
  }
};
